/* eslint-disable array-bracket-newline */
import { useEffect, useState } from 'react';
import Text from '../../../atoms/Text';
import { ICurrentState } from '../../../reducers/current';
import Loader from '../../common/Loader';
import useTickerLivePrice from '../../Watchlist/hooks/useTickerLivePrice';
import CoinNews from '../CoinNews';
import CexCoinInfo from './CexCoinInfo';
import useCexPoolInfo from './useCexPoolInfo';
import { getPriceChange } from '../../../helpers/priceChange';

interface ICexCoinProps {
  current: ICurrentState;
}

enum Tab {
  About = 'About',
  News = 'News',
}

const parseCexInfo = (info?: {
  price: number;
  circulating_supply: number;
  total_supply: number;
  market_cap: number;
}) => {
  return {
    // 'Daily volume': 0,
    'Total Supply': info?.total_supply || 0,
    'Circ. Supply': info?.circulating_supply || 0,
    'Circ. Supply in %':
      ((info?.circulating_supply ?? 0) / (info?.total_supply || 1)) * 100,
    'Fully diluted valuation': (info?.total_supply || 0) * (info?.price || 0),
    'Market Cap': info?.market_cap || 0,
  };
};

const CexCoin = ({ current }: ICexCoinProps) => {
  const { loading, data } = useCexPoolInfo(current.base || '');
  const { price, side } = useTickerLivePrice(current);

  const { priceChange, priceChangePercent } = getPriceChange(
    price.rawPrice,
    current
  );

  const [mode, setMode] = useState<string>('About');

  useEffect(() => {
    if (data && !data?.coin.has_news && mode === Tab.News) {
      setMode(Tab.About);
    }
  }, [data?.coin.has_news]);

  if (loading) {
    return (
      <div className='info_widget'>
        <div className='info_widget__loader'>
          <Loader />
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className='info_widget'>
        <Text size={14} className='notice text--grey-600'>
          Could not fetch data
        </Text>
      </div>
    );
  }

  const mergedData = {
    ...current,
    info: parseCexInfo(data.market),
    ...data.coin,
    price,
    side,
    priceChange,
    priceChangePercent,
  };

  const TABS = [Tab.About];

  return (
    <div className='container'>
      <div className='mode_row'>
        {TABS.map((item) => (
          <div
            key={item}
            className={`text--grey-600 mode_row__item ${
              mode === item ? 'mode_row__item--active' : ' '
            }`}
            onClick={() => setMode(item)}
          >
            <Text size={12}>{item}</Text>
          </div>
        ))}
      </div>
      {mode === 'About' && <CexCoinInfo {...mergedData} />}
      {mode === 'News' && (
        <CoinNews
          slug={data.coin.slug}
          data={data.coin.news}
          AI={data.coin.AI}
        />
      )}
    </div>
  );
};

export default CexCoin;
